module.exports = "/_next/static/images/ec02826c3dbd6da3b909d5173ebe480c-xpeers-mgm-lg.png";